<template>
    <b-card :title="$translate('filters')" class="query-filter filter-form" body-class="p-0 mt-3">
        <div>
            <b-row>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-customer" class="mb-3"><strong>{{ $translate('customer')
                    }}</strong></label>
                <customer-type-ahead v-model="filtersModel.customer_id" />
               </b-col>
                <b-col cols="12" md="6" class="mt-3">
                    <label for="input-activity" class="mb-3"><strong>{{ $translate('activity')
                    }}</strong></label>
                    <b-input type="text" id="search-activity-btn" :placeholder="$translate('search_activity') + ' or ' + $translate('opportunity_name')" v-model="filtersModel.query"></b-input>
                </b-col>
                <b-col md="6" cols="12" class="mt-3 dd">
                    <label for="input-type" class="mb-2"><strong>{{ $translate('activity_type') }}</strong></label>
                    <multiselect id="input-order_type" :placeholder="$translate('select_activity_type')" 
                        v-model="filtersModel.type" 
                        :options="orderTypesArray" 
                        :searchable="true"
                        :multiple="true" 
                        :preserve-search="true"
                        :selectLabel="selectLabel" 
                        
                        label="name" track-by="id" :close-on-select="true">
                               
                    </multiselect>
                </b-col>
            <!-- </b-row>
            <b-row> -->
                <b-col cols="12" md="3" class="mt-3 dd">
                    <label class="mb-3" for="crm_opportunity_type_id"><strong>{{ $translate('crm_opportunity_type')
                            }}</strong></label>
                    <b-form-select class="form-control" id="input-crm_opportunity_type_id" v-model="filtersModel.crm_opportunity_type_id"
                        :options="crm_opportunity_types | mapOptions">
                        <template #first>
                            <b-form-select-option :value="null" selected>
                                {{ $translate('select_option')}}
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" md="3" class="mt-3 dd">
                    <label class="mb-3" for="activity_health_id"><strong>{{ $translate('activity_health')
                            }}</strong></label>
                    <b-form-select class="form-control" id="input-activity_health_id" v-model="filtersModel.activity_health_id"
                        :options="activity_healths | mapOptions">
                        <template #first>
                            <b-form-select-option :value="null" selected>
                                {{ $translate('select_option')}}
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                
            <!-- </b-row>
            <b-row> -->
                <b-col md="3" sm="6" cols="12" class="mt-3 text-start">
                    <label for="input-due_from" class="mb-3"><strong>{{ $translate('due_from') }}</strong></label>
                    <b-form-input type="date" :max="filtersModel.due_to" id="input-due_from"
                        v-model="filtersModel.due_from"></b-form-input>
                </b-col>
                <b-col md="3" sm="6" cols="12" class="mt-3 text-start">
                    <label for="input-due_to" class="mb-3"><strong>{{ $translate('due_to') }}</strong></label>
                    <b-form-input type="date" :min="filtersModel.due_from" id="input-due_to" v-model="filtersModel.due_to"></b-form-input>
                </b-col>
                <b-col md="3" sm="6" cols="12" class="mt-3 text-start">
                    <label for="input-last_meeting_from" class="mb-3"><strong>{{ $translate('last_meeting_from') }}</strong></label>
                    <b-form-input type="date" :max="filtersModel.last_meeting_to" id="input-last_meeting_from"
                        v-model="filtersModel.last_meeting_from"></b-form-input>
                </b-col>
                <b-col md="3" sm="6" cols="12" class="mt-3 text-start">
                    <label for="input-last_meeting_to" class="mb-3"><strong>{{ $translate('last_meeting_to') }}</strong></label>
                    <b-form-input type="date" :min="filtersModel.due_from" id="input-last_meeting_to" v-model="filtersModel.last_meeting_to"></b-form-input>
                </b-col>
                <b-col md="3" sm="6" cols="12" class="mt-3 text-start">
                    <label for="input-last_update_from" class="mb-3"><strong>{{ $translate('last_update_from') }}</strong></label>
                    <b-form-input type="date" :max="filtersModel.last_update_to" id="input-last_update_from"
                        v-model="filtersModel.last_update_from"></b-form-input>
                </b-col>
                <b-col md="3" sm="6" cols="12" class="mt-3 text-start">
                    <label for="input-last_update_to" class="mb-3"><strong>{{ $translate('last_update_to') }}</strong></label>
                    <b-form-input type="date" :min="filtersModel.due_from" id="input-last_update_to" v-model="filtersModel.last_update_to"></b-form-input>
                </b-col>
                <b-col md="3" sm="6" cols="12" class="mt-3 text-start">
                    <label for="input-next_meeting_from" class="mb-3"><strong>{{ $translate('next_meeting_from') }}</strong></label>
                    <b-form-input type="date" :max="filtersModel.next_meeting_to" id="input-next_meeting_from"
                        v-model="filtersModel.next_meeting_from"></b-form-input>
                </b-col>
                <b-col md="3" sm="6" cols="12" class="mt-3 text-start">
                    <label for="input-next_meeting_to" class="mb-3"><strong>{{ $translate('next_meeting_to') }}</strong></label>
                    <b-form-input type="date" :min="filtersModel.due_from" id="input-next_meeting_to" v-model="filtersModel.next_meeting_to"></b-form-input>
                </b-col>
                <b-col md="3" cols="12" class="mt-3 text-start">
                    <label for="input-total" class="mb-3"><strong>{{ $translate('total') }}</strong>
                    </label>

                    <b-input-group>
                        <b-form-input id="input-total" type="number"
                            v-model="filtersModel.total_amount"></b-form-input>
                        <template #prepend>
                            <div class="customselect">
                                <select class="form-control" v-model="filtersModel.quantityType" value-field="id"
                                    text-field="name" block>
                                    <option v-for="x in quantities" :key="'customselect:--' + x.id" :value="x.id">
                                        {{ x.name }}
                                    </option>
                                </select>
                            </div>
                        </template>
                    </b-input-group>
                </b-col>
                <b-col md="3" cols="12" class="dd mt-3">
                    <label class="mb-2"><strong> {{ $translate('customer_agent') }}</strong></label>
                    <b-form-select class="form-control" id="input-customer-agent"
                        v-model="filtersModel.customer_agent_id" :options="customerAgents" text-field="agent_name"
                        value-field="id" required trim>
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate('select_customer_agent')
                            }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="3" cols="12"  class="mt-3 dd">
                    <label class="mb-2"><strong> {{ $translate('officer') }}</strong></label>
                    <b-form-select class="form-control" id="input-officer" value-field="id" text-field="name"
                        v-model="filtersModel.driver_id" :options="officers" >
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate('any_officer')
                            }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
        </div>
    </b-card>
</template>

<script>
import CustomerTypeAhead from "@/components/CustomerTypeAhead.vue";
import Multiselect from 'vue-multiselect';

export default {
    name: 'opportunityStatus-filters',
    data(){
        return {

            orderTypesArray: [],
            quantities: [
                { id: 1, name: '=' },
                { id: 2, name: '>' },
                { id: 3, name: '<' },
            ],
            is_returned_option: [
                {
                value: 1,
                text: this.$translate('yes') 
                },
                {
                value: 0,
                text: this.$translate('no') 
                },
            ],
        }
    },  
    props: ['value', 'orderTypes','customerAgents','officers'],
    components:{CustomerTypeAhead, Multiselect },
    filters: {
        mapOptions(arr) {
            if (!arr || !arr.length) return [];
            return arr
                .filter((x) => x)
                .map((x) => ({
                value: x.id,
                text: x.name,
                }));
        },
    },
    computed: {
        filtersModel: {
            // getter
            get() {
                return this.value
            },
            // setter
            set(val) {
                this.$emit('input', val)
            },
        },
        crm_opportunity_types() {
            const crm_opportunity_types =
                this.$store.state.crmOpportunityTypes.crm_opportunity_types || []
            
            return crm_opportunity_types
        },

        activity_healths() {
            const health = (this.$store.state.health.items_not_paginated || []).map((x) => ({
                ...x,
                name: `${x.title} (${x.start}-${x.end})`,
                }))
            console.log('health', health)
            return health
        },

        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
    },
    async mounted(){
        if(this.orderTypes && this.orderTypes.length > 0){
            this.orderTypesArray = this.orderTypes
        }else{
            await this.$store.dispatch("orderType/fetchAll");
            this.orderTypesArray = this.orderTypes
        }

        if (this.filtersModel.type != "") {
            this.adjustMultiselectHeight();
        }
        console.log('ordertype----------',this.orderTypes);
    },

    watch: {
    'filtersModel.type': {
      handler() {
        this.adjustMultiselectHeight();
      },
      deep: true
    }
    },
    methods: {
        adjustMultiselectHeight() {
        
            setTimeout(() => {
            
                const minHeight = 10;
                const wrappersel = document.querySelector('.multiselect__tags-wrap');
                const calculatedHeight = minHeight + wrappersel.offsetHeight;
                console.log('wrappersel.style.height', wrappersel.offsetHeight, calculatedHeight)
            
                // const multiselectEl = document.querySelector('.multiselect');
                const tagsel = document.querySelector('.multiselect__tags');
                if (tagsel) {
                    // multiselectEl.style.height = `${calculatedHeight}px`;
                    tagsel.style.height =  `${calculatedHeight}px`;
                }
            }, 200);
        }
    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags-wrap {
    display: inline-block;
    height: auto;
}
</style>

